var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.canShowScarcityBar
    ? _c(
        "div",
        {
          staticClass: "rb-scarcity-bar__wrapper",
          class: {
            "rb-scarcity-bar--checkout-page": _vm.isCheckoutPage,
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "rb-scarcity-bar",
              class: _vm.getScarcityBarClasses,
            },
            [
              _c("span", {
                staticClass: "rb-scarcity-bar__saved-amount",
                domProps: { innerHTML: _vm._s(_vm.getScarcityBarText) },
              }),
              _vm._v(" "),
              _vm.canShowCountdown
                ? _c(
                    "span",
                    {
                      staticClass: "rb-scarcity-bar__countdown",
                      class: {
                        "rb-scarcity-bar__countdown--red": _vm.isCountdownRed,
                      },
                    },
                    [
                      _vm._v(
                        "\n       \n      " +
                          _vm._s(_vm.formattedTimeRemain) +
                          "\n    "
                      ),
                    ]
                  )
                : _vm._e(),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }